module.exports = __webpack_public_path__ + "static/media/TRC20.07b7a17f.png";